import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyCr1IlyneHnrnsRbIZAm6GVsU8LPcBCqaM",
    authDomain: "login-bb044.firebaseapp.com",
    databaseURL: "https://login-bb044.firebaseio.com",
    projectId: "login-bb044",
    storageBucket: "login-bb044.appspot.com",
    messagingSenderId: "471239522570",
    appId: "1:471239522570:web:fb99e9e8546c96d7eda2f3"
  };
  const fire = firebase.initializeApp(firebaseConfig);
  export default fire;